import refundMarkdown from "./content/refund.md?raw";
import { LegalPage } from "./LegalPage";
import { LATEST_LEGAL_VERSION } from "./version";
import { Seo } from "@/marketing/Seo";

export function RefundPage() {
  return (
    <>
      <Seo
        title="Refund & Cancellation Policy — Tapelens"
        description="How refunds and cancellations work on Tapelens, including the 14-day trial."
        path="/legal/refund"
      />
      <LegalPage title="Refund & Cancellation Policy" lastUpdated={LATEST_LEGAL_VERSION} markdown={refundMarkdown} />
    </>
  );
}
